import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {KTCard} from '../../../../_metronic/helpers'
import {JudolListHeader} from './components/header/JudolListHeader'
import {JudolEditModal} from './judol-edit-modal/JudolEditModal'
import {JudolTable} from './table/JudolTable'
import {useAuth} from '../../auth'
import {LevelEnum} from '../../../enums/LevelEnum'
import {ReportStatusEnum} from '../../../enums/ReportStatusEnum'

const JudolList = () => {
  const {itemIdForUpdate} = useListView()

  return (
    <>
      <div className='d-flex flex-row justify-content-between mb-8'>
        <h1 className='page-heading text-dark fw-bold fs-3 my-0'>Judi Online</h1>
      </div>
      <KTCard>
        <JudolListHeader />
        <JudolTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <JudolEditModal />}
    </>
  )
}

const JudolListWrapper = () => {

  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <ListViewProvider>
          <JudolList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export {JudolListWrapper}
